import {useState,useMemo,useEffect,useCallback} from "react";
import {useSnackbar} from '../SnackbarContext.js';
import {consoleLog,dateFns_to_db} from '../../../core/utilities/Utilities.js';
import {generateReport} from '../../integration/Api.js';
import COMPONENT_MAP from '../Repository/Components.js';
const file='UserDetailWorkedHours.js';

const UserDetailWorkedHours=({parentId,application,userData})=>{
    const [loading,setLoading]=useState(false);
    const [rows,setRows]=useState([]);
    const [dateFilter,setDateFilter]=useState({
        start:new Date(new Date().getFullYear(),new Date().getMonth(),1),
        end:new Date(new Date().getFullYear(),new Date().getMonth()+1,0)
    });
    const {showSnackbar}=useSnackbar();
    const lang=application?.globalData?.lang;

    const processGenerateReport=useCallback(()=>{
        setLoading(true);
        const firstDayPrevMonth=new Date(new Date().getFullYear(),new Date().getMonth()-1,1);
        const lastDayPrevMonth=new Date(new Date().getFullYear(),new Date().getMonth(),0);
        const start_date_prev_month=dateFns_to_db(firstDayPrevMonth)+" 00:00:00";
        const end_date_prev_month=dateFns_to_db(lastDayPrevMonth)+" 00:00:00";
        const now=new Date();
        const prevMonth=new Date(now.getFullYear(),now.getMonth()- 1,1);
        const mm=String(prevMonth.getMonth()+1).padStart(2,'0');
        const yyyy=prevMonth.getFullYear();
        const last_month_label=` (${mm}.${yyyy})`;
        const reportParams=[
            "start_date="+dateFns_to_db(dateFilter.start)+" 00:00:00",
            "end_date="+dateFns_to_db(dateFilter.end)+" 00:00:00",
            "start_date_prev_month="+start_date_prev_month,
            "end_date_prev_month="+end_date_prev_month,
            "last_month_label="+last_month_label,
            "system_user_id="+parentId,'_lang='+lang];
        consoleLog({file:file,context:'processGenerateReport',arg_name:'reportParams',arg_value:reportParams});
        generateReport({reportType:'user_worked_hours',reportParams:reportParams})
        .then((data)=>{
            consoleLog({file:file,context:'processGenerateReport - generate_report',arg_name:'data',arg_value:data});
            if('error' in data){
                showSnackbar(data.error,'error');
            }
            else if(data.length>0){
                setRows(old=>data);
            }
            else{
                setRows(old=>[]);
            }
            setLoading(false);
        });
    },[dateFilter,parentId,lang,showSnackbar]);

    useEffect(()=>{
        if(parentId){
            processGenerateReport();
        }
    },[dateFilter,parentId,processGenerateReport]);

    const renderFilterDate=useCallback(()=>{
        const Component=COMPONENT_MAP['FilterDate'];
        return Component?(
            <Component
                dateFilter={dateFilter}
                setDateFilter={setDateFilter}
                application={application}
            />
        ):null;
    },[dateFilter,application]);

    const handleClickEvent=useCallback((args)=>{
        consoleLog({file:file,context:'handleClickEvent',arg_name:'click_event',arg_value:args});
        switch(args?.action){
            case "generateReport":
                setRows(old=>[]);
                processGenerateReport();
                break;
            default:
                break;
        }
    },[processGenerateReport]);

    const renderList=useMemo(()=>{
        const Component=COMPONENT_MAP['List'];
        return Component?(
            <Component
                records={rows}
                list_name={'user_worked_hours'}
                loading={loading}
                height={'50vh'}
                file={file}
                application={application}
                initialState={{}}
                entityRules={{}}
                userData={userData}
                actions={{}}
                handleClickEvent={handleClickEvent}
                filterComponent={renderFilterDate()}
                //button_actions={[{name:'generateReport',label:'ButtonGenerateReport',args:{}}]}
                noRefresh={true}
            />
        ):null; 
    },[rows,loading,application,userData,handleClickEvent,renderFilterDate])

    return(renderList);
}

export default UserDetailWorkedHours;
